// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"222":"115de0cb","316":"134d78a6","356":"134d78a6","542":"115de0cb","634":"bffdd409","641":"115de0cb","696":"115de0cb","859":"115de0cb","860":"134d78a6","973":"134d78a6"}[chunkId] + ".chunk.css";
};